<section class="content">

    <ng-container *ngIf="messages && messages.length > 0">
      <mat-card class="mt-3 me-3">
        <mat-card-content>
          <div class="row text-muted" *ngFor="let message of messages">
            <div [innerHTML]="message.message"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
  
      <ng-container *ngFor="let projectStats of projectsStats">
        <mat-card class="mt-3 me-3">
          <mat-card-header>
            <mat-card-title>{{projectStats.name}} Statistics</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="ps-2 row text-muted" *ngFor="let stat of projectStats.stats; let i = index">
              <div class="col-10" [style]="{'padding-left': 10*(i>0?2:1)+'px'}">{{stat.name.replace("Docs", "Documents").replace("Error", "Issue Resolution")}}:</div>
              <div class="col-2 text-end">{{stat.value}}</div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
  
      <ng-container *ngIf="userStats && userStats.size > 0">
        <mat-card class="mt-3 me-3" *ngFor="let statGroup of userStats | keyvalue: specificOrder ">
          <mat-card-header>
            <mat-card-title>My {{statGroup.key}}s</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="ps-2 row text-muted" *ngFor="let stat of statGroup.value">
              <div class="col-7" [style]="{'padding-left': 10*(stat.name.split('|').length-1)+'px'}">{{stat.name.split('|')[stat.name.split('|').length-1]}}:</div>
              <div class="col-5 text-end">{{stat.value}}</div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>

  </section>
  